export default __webpack_public_path__ + "static/IBM-Plex-Mono-700italic-06ddc6fbb9d80518381d085dfad24a0a.woff";